import { useStatusOverlay } from '@fs/zion-ui'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useZionAxios } from '@fs/zion-axios'
import { useUserIsDataAdmin } from '../providers/DataAdminProvider'

export default function useGroupMembers(groupId) {
  const [t] = useTranslation()
  const showStatusOverlay = useStatusOverlay()
  const url = groupId ? `/service/tree/tree-data/groups/${groupId}/members` : null
  const [{ data, error }, refetch] = useZionAxios(url)
  const { userIsDataAdmin } = useUserIsDataAdmin()

  useEffect(() => {
    if (error) {
      console.error(error)
      if (error.status === 410 && userIsDataAdmin) {
        showStatusOverlay({
          type: 'error',
          message: t('This group has been deleted.'),
        })
      } else {
        showStatusOverlay({ type: 'error', message: t('group-management.group-members.error') })
      }
    }
  }, [error, showStatusOverlay, t, userIsDataAdmin])

  const members = (data?.members ?? []).filter((member) => ['ADMIN', 'MEMBER'].includes(member.status))
  const pendingMembers = (data?.members ?? []).filter((member) => member.status === 'PENDING')

  return { data: { members, pendingMembers }, loading: !data, error, refetch }
}
